// extracted by css-extract-rspack-plugin
export default {"header":"src-app-components-layout-CalendarLayout-CalendarLayout-module__header-wByTzi","dayRow":"src-app-components-layout-CalendarLayout-CalendarLayout-module__dayRow-YLjlM_","dayContainer":"src-app-components-layout-CalendarLayout-CalendarLayout-module__dayContainer-cLP5cQ","title":"src-app-components-layout-CalendarLayout-CalendarLayout-module__title-UzmDT7","disabled":"src-app-components-layout-CalendarLayout-CalendarLayout-module__disabled-rhlwDV"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"header\":\"src-app-components-layout-CalendarLayout-CalendarLayout-module__header-wByTzi\",\"dayRow\":\"src-app-components-layout-CalendarLayout-CalendarLayout-module__dayRow-YLjlM_\",\"dayContainer\":\"src-app-components-layout-CalendarLayout-CalendarLayout-module__dayContainer-cLP5cQ\",\"title\":\"src-app-components-layout-CalendarLayout-CalendarLayout-module__title-UzmDT7\",\"disabled\":\"src-app-components-layout-CalendarLayout-CalendarLayout-module__disabled-rhlwDV\"}";
        // 1789362522820
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  